<div class="input-container mt-4">
	<p class="title">{{title}}</p>
	<div class="input-uploader">
		<label for="input-{{selector}}" appDragDrop (fileDropped)="onFileDropped($event)" class="input-label">
			<span>{{tooltipText}}</span>
			<i class="ic-upload input-icon-upload"></i>
		</label>
		<input
			id="input-{{selector}}"
			class="d-none"
			type="file"
			(change)='onSelect($event)'
			[multiple]="multiple"
			[(ngModel)]="uploadFileInput"
			/>
	</div>
</div>
